const Layout = () => import (`@/page/index/index.vue`);
const MobileLayout = () => import ( /* webpackChunkName: "index" */ `@/mobile/mobileLayout.vue`);
import mobile from './mobile/index'
import cost from './cost/cost';
import policy from './policy/policy';
import subRouter from './subrouter';
import accounting from "@/router/accounting/accounting";

export const constantRoutes = [
  {
    path: '/',
    name: '主页',
    redirect: '/login',
  },
  // {
  //   path: '/:tenant/login',
  //   name: '登录',
  //   component: () => import ( /* webpackChunkName: "login" */ `@/page/new-login/index.vue`),
  // },
  {
    path: '/login-v1',
    name: '登录',
    component: () => import ( /* webpackChunkName: "login" */ `@/page/new-login/index.vue`),
  },
  {
    path: '/login',
    name: '登录',
    component: () => import ( /* webpackChunkName: "login" */ `@/views/login/index.vue`),
  },
  {
    path: '/switchlogout',
    name: '选择退出登录地址',
    component: () => import ( /* webpackChunkName: "login" */ `@/views/login/switchlogout.vue`),
  },
  {
    path: '/lock',
    name: '锁屏',
    component: () => import ( /* webpackChunkName: "lock" */ `@/page/lock/index.vue`),
  },

  {
    path: '/404',
    component: () => import ( /* webpackChunkName: "404" */ `@/components/ciic/error-page/404.vue`),
    name: '404',
  },
  {
    path: '/403',
    component: () => import ( /* webpackChunkName: "403" */ `@/components/ciic/error-page/403.vue`),
    name: '403',
  },
  {
    path: '/500',
    component: () => import ( /* webpackChunkName: "500" */ `@/components/ciic/error-page/500.vue`),
    name: '500',
  },
  {
    path: '/mobile',
    name: 'MobileLayout',
    component: MobileLayout,
    children: [
      ...mobile
    ]
  }
];
export const asyncRoutes = [
  {
    path: '/',
    component: Layout,
    children: [...subRouter, ...policy, ...cost, ...accounting]
  }
]
